import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavbarCutout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 260,
	height: 64,
	viewBox: "0 0 390 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M-27 9C-27 -4.80712 -15.8071 -16 -2 -16H415.689C439.214 -16 449.716 13.5363 431.471 28.3883L350.394 94.3883C345.935 98.0181 340.361 100 334.611 100H-2C-15.8071 100 -27 88.8071 -27 75V9Z",
		fill: "#EB0A23"
	})
});
export default SvgNavbarCutout;
